module.exports = __webpack_public_path__ + "media/images/pc/top/area_brand_sola-130758d0b2061b3a7527e40cc8962e7a.webp";